import { _get } from '@/common/request';
export default {
    state: {
        companyList: [],
    },
    actions: {
        // 动态获取企业列表
        $_GetCompanyList: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                _get('/property/user/companies', null, true).then(function (res) {
                    commit('UPDATE_COMPANY_LIST', res.data);
                    resolve(res.data);
                }, function (err) {
                    reject(err);
                });
            });
        },
    },
    mutations: {
        // 更新企业列表
        UPDATE_COMPANY_LIST: function (state, data) {
            state.companyList = data;
        },
    },
    getters: {},
};
